import React from "react";
import { Outlet } from 'react-router-dom';
import "../../App.css";
import {Header} from "./Header";
import {Footer} from "./Footer";
import ScrollToTop from "./ScrollToTop";

export const Layout = (props) => {
    return (
        <>
            <ScrollToTop />
            <Header />
            <Outlet />
            <Footer />
        </>
    );
};
